import { render, staticRenderFns } from "./ConsumoPromedio.vue?vue&type=template&id=99e9f4e2"
import script from "./ConsumoPromedio.vue?vue&type=script&lang=js"
export * from "./ConsumoPromedio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports